import { FC, ReactNode, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Colors, Dropdown, DropdownListItem, useBreakpoint, useIsMobile } from '@brg/ui';

import {
  DropdownItemsWrapper,
  SlideNavigationItemsWrapper,
  SlideNavigationWrapperItem,
} from './styles';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  
  svg {
    z-index: 0 !important;
  }
`;
import { SlideNavigationLayout } from './slideNavigationLayout';
import { TagsCoor, TagsPopUp } from '../TagsPopUp/TagsPopUp';
import { SlideWithHover } from './slideWithHover';
import {ScrollableSlideNavigationItems} from "./ScrollableSlideNavigationItems";
import useQueryState from 'shared/hooks/useQueryState';
import { MoreButton } from '../more-button';
import { useTranslation } from 'react-i18next';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { AppTester } from "../../../supporting";
import { LayoutConst } from 'core';
import { useSelector } from 'react-redux';
import { ThemeSlideColorSelector } from 'shared/reducers/ThemeSlideColorSlice';
import { useRouteMatch } from 'react-router-dom';
// @ts-ignore
import { TFunctionResult } from 'i18next';
import { HoverContainer } from './components/HoverContainer';

//const MAX_ROW_COUNT = 4;
//const CUT_LAST_TAB = 3;
const INITIAL_ROW_COUNT = 10;
const SEARCH_BAR_WIDTH = 300;

type TSceletonProps = {
  col: string | number;
  w: number | string;
  h: number | string;
  gx: number
}

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: ReactNode;
}

export interface SceletonProps {
  sceletonOptions?: TSceletonProps
}

export interface SlideNavigationProps extends SceletonProps {
  items?: Record<string, ReactNode | string | LinksItems | TFunctionResult>;
  onChange?: (indexKey: string) => void;
  activeIndexKey?: string;
  isLoading?: boolean;
  whiteTheme?: any;
  autoWidth?: boolean;
  autoFlex?: boolean;
  padding?: number;
  whiteSpace?: boolean;
  disableTab?: boolean;
  isSuperPuperGames?: boolean;
  isTitle?: boolean;
  overflowX?: boolean;
  isProfile?: boolean;
  capitalize?: boolean;
  blueSelect?: boolean;
  hoverPopup?: boolean;
  isDesigner?: boolean;
  hoverContent?: any;
  hoverDataName?: any;
  dropdownWhiteTheme?:any;
  stretch?: boolean;
  isDropdown?: boolean;
  arrowIconId?: string;
  fullWidth?: boolean;
  floatingTabs?:boolean;
  smallTab?: boolean;
  isCompetition?: boolean;
  customDropdownTheme?: any;
  maxVisibleItems?: number;
  onTagClick?: (data: any) => void;
  colors?: any;
  isLMSHomework?: boolean
}

const SlideNavigation: FC<SlideNavigationProps> = ({
  onChange,
  items,
  activeIndexKey,
  autoWidth,
  autoFlex,
  isLoading,
  whiteTheme,
  whiteSpace,
  padding,
  sceletonOptions,
  disableTab,
  isTitle,
  overflowX,
  capitalize,
  arrowIconId = '',
  blueSelect,
  hoverPopup,
  hoverContent,
  hoverDataName,
  isDesigner,
  stretch,
  fullWidth,
  isDropdown,
  dropdownWhiteTheme,
  floatingTabs,
  smallTab,
  isCompetition,
  onTagClick,
  isLMSHomework,
  isSuperPuperGames
}) => {
  const tabsContainerRef = useRef<any>(null);
  const langRef = useRef<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hoverPopUpRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const [pos,setPos] = useState<TagsCoor>({x: null, y: null });
  const [rowCount, setRowCount] = useState<number>(INITIAL_ROW_COUNT)
  const [{ tab }] = useQueryState();
  const [sizesInfo, setSizes] = useState<Record<string,number>>({})
  const [titleSize, setTitleSize] = useState(0)
  const [hoverElem, setHoverElem ] = useState<string | null>(null);
  const [localLoading, setLocalLoading] = useState(false);
  const [activeDropdownTab, setActiveDropdownTab ] = useState<any>(null);
  const leaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;
  const isTeamEdit = useRouteMatch('/team-edit');
  const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
  const isMobile = useIsMobile();
  const is743 = useBreakpoint(LayoutConst.container.s - 1)
  const is1200 = useBreakpoint(LayoutConst.container.l)
  const designerBarWidth = is1200 ? 120 : 180;

  const onChangeHandler = useCallback((key: string, isTest?: boolean) => () => {
    onChange?.(key);
  }, [onChange]);

  const onSetHoverTab = useCallback((val: string | null) => {
    if (val !== null && leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    
    if (val === null) {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
      leaveTimeoutRef.current = setTimeout(() => {
        setHoverElem(null);
        leaveTimeoutRef.current = null;
      }, 150);
    } else {
      setHoverElem(val);
    }
  }, [])

  const onSetSizes = useCallback((props: any) => {
    const {idx, width, item} = props

    setSizes((prev: any) => {
        const newSizes = {...prev}
        newSizes[item] = width
        return newSizes
    })
}, [])

  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const is992 = useBreakpoint(LayoutConst.screen.m);

  const offsetVisible = useMemo(() => (!!tab), [tab]);

  const isHseDeziiign = AppTester.isHSEDesign();
  const gameSpecialCondition = isSuperPuperGames && is992 && !is743;

  const maxRowCount = gameSpecialCondition ? 4 : rowCount;
  const cutLastTab = maxRowCount - 1

  const computeItems = useMemo(() => {
    if (items && !isLoading && !localLoading) {
      if (Object.keys(items)?.length > maxRowCount) {
        if (activeDropdownTab) {
          const visibleItems = Object.entries(items)?.slice(0, cutLastTab);
          const activeTabEntry = activeDropdownTab;
          return [...visibleItems, activeTabEntry]?.reduce((a,[k,v]) => ({...a, [k]: v}), {});
        }
        return Object.entries(items)?.slice(0, maxRowCount)?.reduce((a,[k,v]) => ({...a, [k]: v}), {});
      }
      return items;
    }
    return items
  }, [items, isDropdown, isLoading, localLoading, activeDropdownTab, maxRowCount, cutLastTab])


  const computedDropdownItems = useMemo<Record<string, LinksItems> | null>(() => {
    if (items && !isLoading && !localLoading) {
      const activeTab = activeIndexKey ? activeDropdownTab?.[0]: undefined;
      const lastTabInRow: [string,string] | [] = activeDropdownTab ? Object.entries(items)?.[Object.entries(items)?.slice(0,maxRowCount)?.length - 1] : [];

      if (Object.keys(items)?.length > maxRowCount) {
        const lastTabRow = !!lastTabInRow ? lastTabInRow : []
        const filteredItems = [...Object.entries(items), lastTabRow];

        return filteredItems
          ?.slice(maxRowCount, filteredItems?.length)
          ?.filter(([k, v]) => activeTab ? k !== activeTab : k )
          ?.reduce((a,[k,v]) => ({...a, [k || '']: v}), {})
      }
      return null;
    }
    return null;
  } , [
    items,
    isLoading,
    localLoading,
    activeDropdownTab,
    activeIndexKey,
    maxRowCount
  ])

  const rightSideWidth = useMemo(() => {
    return document.querySelector('.js-right-side-box')?.clientWidth || 0
  } , [dropdownRef?.current])

  const searchBarWidth = useMemo(
    () => (
      rightSideWidth > 0 ? rightSideWidth : 
      isDesigner ? designerBarWidth : 
      (isTeamEdit || (isTeamOrCoursePage && !isMobile)) ? 0 : 
      SEARCH_BAR_WIDTH) 
  , [isDesigner, rightSideWidth])

  useEffect(() => {
    //костыль для ресета размера элементов при смене языка
    if (langRef.current !== i18n.language) {
      setSizes({})
      setLocalLoading(true)
    }
    langRef.current = i18n.language
    setLocalLoading(false);
  } , [i18n.language])

  useEffect(() => {
    return () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, [])

  useEffect(() => {
    if(tabsContainerRef?.current && hoverElem) {
      const el = tabsContainerRef.current?.querySelector(`[data-title="${hoverElem}"]`);
      const key = el?.dataset?.['title'];

      if (computedDropdownItems && Object.keys(computedDropdownItems)?.includes(key) && dropdownRef.current) {
        setPos({
          x: dropdownRef.current.offsetLeft || 0,
          y: el?.offsetTop
        });
        return;
      }
      if (el) {
        setPos({ x: el?.offsetLeft, y: 0 });
      }
    } else if (!hoverElem) {
      setPos({ x: null, y: null });
    }
  }, [tabsContainerRef, hoverElem, computedDropdownItems, dropdownRef])

  useEffect(() => {

    if (!computedDropdownItems) return;

    const isDropdownOpen = dropdownRef.current?.querySelector('.show')

    const hasItemIntoDropdown = Object.keys(computedDropdownItems)?.includes(hoverElem ?? '')

    if (hasItemIntoDropdown) return;

    if (hoverElem && isDropdownOpen) {
      isDropdownOpen?.classList.remove('show')
    }

  } , [dropdownRef?.current, hoverElem, computedDropdownItems])

  useEffect(() => {
    if (activeIndexKey && computedDropdownItems) {
      const activeItem = Object.entries(computedDropdownItems)?.find(([k, v]) => k === activeIndexKey);

      if (activeItem?.length) {
        setActiveDropdownTab(activeItem)
      }

    } else {
      setActiveDropdownTab(null)
    }
  }, [activeIndexKey, isDropdown, computedDropdownItems, i18n.language, t, items])


  const calcGap = useCallback(() => {
    if (is992) return 16;
    return 24;
  }, [is992])

  const calcRow = useCallback((maxWidth: number) => {
    const currentCountGap = (n: number) => calcGap() * n - 1

    let result = { overWidth: 0, lastRow: 0 };

    Object.entries(sizesInfo).forEach(([item, width], idx, arr) => {
      if (result.lastRow > 0) return;


      if (((result.overWidth + (width as number)) + currentCountGap(idx)) > maxWidth) {
        result = { overWidth: result.overWidth, lastRow: idx - 1 };
        return;
      }
      result = { overWidth: result.overWidth += (width as number), lastRow: 0 };
    });

    return result;
  } , [sizesInfo, calcGap])

  const onSetRowCount = useCallback((data: any) => {
    if (data !== rowCount && !!data) {
      setRowCount(data)
    }
  } , [rowCount])
 

  const countDuplicates = useCallback((arr: any[]) => {
    const counts = arr.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});
    // @ts-ignore
    return Object.values(counts).filter(count => count > 1).length;
  }, []);

  useLayoutEffect(() => {
    if (localLoading) return
    const mobileSeachBarWidth = isTeamOrCoursePage && isMobile && !is743 ? 0 : searchBarWidth

    const mainContainerWidth = !!is992 ?  LayoutConst.container.xs : !!is1280 ? LayoutConst.container.m : LayoutConst.container.l
    const maxContainerWidth = mainContainerWidth - mobileSeachBarWidth;
    
    //@ts-ignore
    const computeItemsValues = Object.values(computeItems);
    const sizesInfoValues = Object.values(sizesInfo);
    
    // Подсчитываем количество дублирующихся элементов в computeItems
    const duplicateCount = countDuplicates(computeItemsValues);

    // Новая длина sizesInfo, учитывающая дублирующиеся элементы
    const adjustedSizesInfoLength = sizesInfoValues.length + duplicateCount;

    if ((adjustedSizesInfoLength === computeItemsValues.length || adjustedSizesInfoLength > computeItemsValues.length) && !isLoading) {
      const baseGap = calcGap() * adjustedSizesInfoLength;
      const overWidth = sizesInfoValues.reduce((acc, val) => acc + val, 0);
      const baseValue = items && Object.values(items)?.length > 0 ? Object.values(items)?.length : INITIAL_ROW_COUNT;
      const needBreak = (overWidth + baseGap) > maxContainerWidth;

      if (!needBreak) {
        onSetRowCount(baseValue);
        return;
      }

      const { lastRow } = calcRow(maxContainerWidth);
      onSetRowCount(lastRow)
  }
  } , [
    sizesInfo,
    activeDropdownTab,
    searchBarWidth,
    tabsContainerRef.current,
    computeItems,
    isLoading,
    localLoading,
    items,
    is1280,
    is992,
    onSetRowCount,
    calcGap,
    calcRow,
    countDuplicates
  ])

  const activeDropdownItem = useMemo(() => {
    if (!activeDropdownTab) return null;

    const [key, item] = activeDropdownTab;
    const title = typeof item === 'string' ? item : item?.element?.();
    setTitleSize(title.length)
    return (
      <SlideNavigationWrapperItem
        className={"white_theme_project_underline"}
        isDesigner={isDesigner}
        isHseDeziiign={isHseDeziiign}
        onClick={onChangeHandler(key)}
        onMouseEnter={() => onSetHoverTab(key)}
        active={key === activeIndexKey}
        //@ts-ignore
        dataName={hoverDataName?.[key]}
        data-title={key}
        white_theme={whiteTheme}
        padding={padding}
        whiteSpace={whiteSpace}
        blueSelect={blueSelect}
        disableTab={key !== activeIndexKey && disableTab}
        isTitle={isTitle}
        smallTab={smallTab}
        offsetVisible={offsetVisible}
        floatingTabs={floatingTabs}
        isTeamOrCoursePage={isTeamOrCoursePage}
      >
        {title}
      </SlideNavigationWrapperItem>
    )
  } , [
    activeDropdownTab, 
    activeIndexKey, 
    computeItems,
    items, 
    hoverDataName, 
    t, 
    onSetHoverTab, 
    disableTab, 
    isDesigner, 
    whiteTheme,  
    isTitle, 
    smallTab, 
    items, 
    i18n.language, 
    offsetVisible, 
    blueSelect 
  ])

  const dropdown = useMemo(() => {

    if (!computedDropdownItems) return null;

    return (
        <DropdownItemsWrapper
          isCompetition={isCompetition}
          //todo вынести выше или в тему
          isWhite={dropdownWhiteTheme}
          ref={dropdownRef}
          rightPos={titleSize > 8}
          leftPos={isLMSHomework && titleSize === 0}
        >
          <Dropdown
              hideArrow
              maxWidth={403}
              dark={whiteTheme}
              offsetX={-180}
              orientation='left'
              {...(dropdownWhiteTheme && { maxHeight: 300 })}
              target={
                <MoreButton
                  onClick={() => setHoverElem(null)}
                />
              }
          >
            {Object.keys(computedDropdownItems)?.map((item, idx, arr) => {
              const isLink = typeof computedDropdownItems[item] !== 'string';
              return (
                  <DropdownListItem
                  //@ts-ignore
                    dataName={hoverDataName?.[item]}
                    data-title={item}
                    onMouseEnter={() => onSetHoverTab(item)}
                    isActive={item === activeIndexKey}
                    onClick={isLink ? computedDropdownItems[item].action : onChangeHandler(item)}
                    key={idx}
                  >
                    {/*@ts-ignore*/}
                    {(typeof computedDropdownItems[item] === 'string' ? computedDropdownItems[item] : computedDropdownItems[item]?.element?.() || '')?.toLowerCase?.()}
                  </DropdownListItem>
              )
            })}
                  </Dropdown>
        </DropdownItemsWrapper>
    )
  } , [computedDropdownItems, onChangeHandler, activeIndexKey, hoverDataName, hoverContent, isCompetition, hoverElem, pos, blueSelect, dropdownWhiteTheme])

  const visibleItems = computeItems;

  const handleTagClick = useCallback((tagId: string) => {
    if (onTagClick) {
      onTagClick({ tagId, tab: hoverElem })
    }
  }, [hoverElem]);

  const onHoverPopupMouseEnter = useCallback(() => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
  }, []);

  const onHoverPopupMouseLeave = useCallback((event: MouseEvent) => {
    const relatedTarget = event.relatedTarget as Node;
    const currentTarget = event.currentTarget;

    //@ts-ignore
    if (relatedTarget instanceof Node && currentTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    onSetHoverTab(null)
  }, [onSetHoverTab]);



  const tabsComponent = useMemo(() => {
    if (hoverPopup && hoverContent && hoverDataName ) {
      return (
        <HoverContainer 
          hoverRef={hoverPopUpRef}
          onMouseEnter={onHoverPopupMouseEnter}
          onMouseLeave={onHoverPopupMouseLeave}
        >
        <SlideNavigationLayout
          autoWidth={autoWidth}
          autoFlex={autoFlex}
          isDesigner={isDesigner}
          isLoading={isLoading || localLoading}
          content={
            visibleItems ? (
            <SlideNavigationItemsWrapper ref={tabsContainerRef} wrap="nowrap" wrapMobile="nowrap" offsetBottomMobile={-4} isDesigner={isDesigner} overflowX={overflowX}>
              {Object.keys(visibleItems).map((key) => {
                const isLink = typeof items?.[key] !== 'string';
                return (
                  <SlideWithHover 
                    key={key}
                    //@ts-ignore
                    onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                    active={key === activeIndexKey}
                    whiteTheme={whiteTheme}
                    isDesigner={isDesigner}
                    blueSelect={blueSelect}
                    padding={padding}
                    whiteSpace={whiteSpace}
                    disableTab={key !== activeIndexKey && disableTab}
                    isTitle={isTitle}
                    dataName={hoverDataName[key]}
                    dataTitle={key}
                    onSetSizes={onSetSizes}
                    onSetActiveTab={onSetHoverTab}
                    importantItemColor={importantItemColor}
                    //@ts-ignore
                    item={isLink ? items[key]?.element() : capitalize ? items[key] : items[key]}
                  />
                )
              })}
              {dropdown}
            </SlideNavigationItemsWrapper>
          ) : null
        }
          sceletonOptions={sceletonOptions}
        />
        <TagsPopUp 
          list={hoverContent} 
          currentTab={hoverElem} 
          visible={!!hoverElem} 
          coor={pos} 
          blueSelect={blueSelect} 
          onTagClick={onTagClick ? handleTagClick : undefined}
          onMouseEnter={onHoverPopupMouseEnter}
        />
      </HoverContainer>
      )
    }
    return (
      <SlideNavigationLayout
      autoWidth={autoWidth}
      autoFlex={autoFlex}
      isDesigner={isDesigner}
      isLoading={isLoading || localLoading}
      stretch={stretch}
      fullWidth={fullWidth}
      content={
        computeItems ? (
          <ScrollableSlideNavigationItems isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} isTitle={isTitle}>
            {Object.keys(computeItems).sort((a, b) => a === 'competitionCerts' ? 1 : b === 'competitionCerts' ? -1 : 0).map((key, idx, arr) => {
              //@ts-ignore
              const isLink = typeof computeItems[key] !== 'string';
              //@ts-ignore
              const isEmptyProjects = typeof computeItems[key] === 'string' && computeItems[key]?.split('|')[1]?.trim() === '0'
 
              return (
                // @ts-ignore
                <SlideWithHover
                  key={key}
                  //@ts-ignore
                  onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                  active={key === activeIndexKey}
                  whiteTheme={whiteTheme}
                  isDesigner={isDesigner}
                  blueSelect={blueSelect}
                  padding={padding}
                  whiteSpace={whiteSpace}
                  disableTab={key !== activeIndexKey && disableTab}
                  isTitle={isTitle}
                  onSetSizes={onSetSizes}
                  isEmptyProjects={isEmptyProjects}
                  //@ts-ignore
                  item={isLink ? items[key]?.element() : capitalize ? items[key] : items[key]}
                >
                {/*@ts-ignore*/}
                {isLink ? computeItems[key]?.element() : capitalize ? computeItems[key] : computeItems[key]}
                {arrowIconId === key && (
                  <ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                )}
              </SlideWithHover>
              )
            })}
            <DropdownWrapper>
              {dropdown}
            </DropdownWrapper>
          </ScrollableSlideNavigationItems>
        ) : null
      }
      sceletonOptions={sceletonOptions}
    />
    )
  } , [
    computeItems, 
    visibleItems, 
    i18n.language, 
    localLoading,
    hoverElem,
    pos,
    activeDropdownItem,
    activeIndexKey,
    sceletonOptions,
    blueSelect,
    isDesigner,
    whiteTheme,
    isLoading,
  ])

  return tabsComponent
};

export default SlideNavigation;
import { FC, ReactNode, useCallback, useEffect, useLayoutEffect, useMemo, useRef, useState } from 'react';
import { Colors, Dropdown, DropdownListItem, useBreakpoint, useIsMobile } from '@brg/ui';

import {
  DropdownItemsWrapper,
  SlideNavigationItemsWrapper,
  SlideNavigationWrapperItem,
} from './styles';
import styled from 'styled-components';

const DropdownWrapper = styled.div`
  position: relative;
  
  svg {
    z-index: 0 !important;
  }
`;
import { SlideNavigationLayout } from './slideNavigationLayout';
import { TagsCoor, TagsPopUp } from '../TagsPopUp/TagsPopUp';
import { SlideWithHover } from './slideWithHover';
import {ScrollableSlideNavigationItems} from "./ScrollableSlideNavigationItems";
import useQueryState from 'shared/hooks/useQueryState';
import { MoreButton } from '../more-button';
import { useTranslation } from 'react-i18next';
import { ArrowCornerSvg } from 'shared/assets/16/ArrowCornerSvg';
import { AppTester } from "../../../supporting";
import { LayoutConst } from 'core';
import { useSelector } from 'react-redux';
import { ThemeSlideColorSelector } from 'shared/reducers/ThemeSlideColorSlice';
import { useRouteMatch } from 'react-router-dom';
// @ts-ignore
import { TFunctionResult } from 'i18next';
import { HoverContainer } from './components/HoverContainer';

//const MAX_ROW_COUNT = 4;
//const CUT_LAST_TAB = 3;
const INITIAL_ROW_COUNT = 10;
const SEARCH_BAR_WIDTH = 300;

type TSceletonProps = {
  col: string | number;
  w: number | string;
  h: number | string;
  gx: number
}

export interface LinksItems {
  action: () => void;
  isLinks: boolean;
  element: ReactNode;
}

export interface SceletonProps {
  sceletonOptions?: TSceletonProps
}

export interface SlideNavigationProps extends SceletonProps {
  items?: Record<string, ReactNode | string | LinksItems | TFunctionResult>;
  onChange?: (indexKey: string) => void;
  activeIndexKey?: string;
  isLoading?: boolean;
  whiteTheme?: any;
  autoWidth?: boolean;
  autoFlex?: boolean;
  padding?: number;
  whiteSpace?: boolean;
  disableTab?: boolean;
  isSuperPuperGames?: boolean;
  isTitle?: boolean;
  overflowX?: boolean;
  isProfile?: boolean;
  capitalize?: boolean;
  blueSelect?: boolean;
  hoverPopup?: boolean;
  isDesigner?: boolean;
  hoverContent?: any;
  hoverDataName?: any;
  dropdownWhiteTheme?:any;
  stretch?: boolean;
  isDropdown?: boolean;
  arrowIconId?: string;
  fullWidth?: boolean;
  floatingTabs?:boolean;
  smallTab?: boolean;
  isCompetition?: boolean;
  customDropdownTheme?: any;
  maxVisibleItems?: number;
  onTagClick?: (data: any) => void;
  colors?: any;
  isLMSHomework?: boolean
}

const SlideNavigation: FC<SlideNavigationProps> = ({
  onChange,
  items,
  activeIndexKey,
  autoWidth,
  autoFlex,
  isLoading,
  whiteTheme,
  whiteSpace,
  padding,
  sceletonOptions,
  disableTab,
  isTitle,
  overflowX,
  capitalize,
  arrowIconId = '',
  blueSelect,
  hoverPopup,
  hoverContent,
  hoverDataName,
  isDesigner,
  stretch,
  fullWidth,
  isDropdown,
  dropdownWhiteTheme,
  floatingTabs,
  smallTab,
  isCompetition,
  onTagClick,
  isLMSHomework,
  isSuperPuperGames
}) => {
  const tabsContainerRef = useRef<any>(null);
  const langRef = useRef<any>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const hoverPopUpRef = useRef<HTMLDivElement>(null);
  const { t, i18n } = useTranslation();
  const [pos,setPos] = useState<TagsCoor>({x: null, y: null });
  const [rowCount, setRowCount] = useState<number>(INITIAL_ROW_COUNT)
  const [{ tab }] = useQueryState();
  const [sizesInfo, setSizes] = useState<Record<string,number>>({})
  const [titleSize, setTitleSize] = useState(0)
  const [hoverElem, setHoverElem ] = useState<string | null>(null);
  const [localLoading, setLocalLoading] = useState(false);
  const [activeDropdownTab, setActiveDropdownTab ] = useState<any>(null);
  const leaveTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const importantItemColor = useSelector(ThemeSlideColorSelector)?.slideColor;
  const isTeamEdit = useRouteMatch('/team-edit');
  const isTeamOrCoursePage = !!useRouteMatch(['/teams', '/courses']);
  const isMobile = useIsMobile();
  const is743 = useBreakpoint(LayoutConst.container.s - 1)
  const is1200 = useBreakpoint(LayoutConst.container.l)
  const designerBarWidth = is1200 ? 120 : 180;

  const onChangeHandler = useCallback((key: string, isTest?: boolean) => () => {
    onChange?.(key);
  }, [onChange]);

  const onSetHoverTab = useCallback((val: string | null) => {
    if (val !== null && leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
    
    if (val === null) {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
      leaveTimeoutRef.current = setTimeout(() => {
        setHoverElem(null);
        leaveTimeoutRef.current = null;
      }, 150);
    } else {
      setHoverElem(val);
    }
  }, [])

  const onSetSizes = useCallback((props: any) => {
    const {idx, width, item} = props

    setSizes((prev: any) => {
        const newSizes = {...prev}
        newSizes[item] = width
        return newSizes
    })
}, [])

  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const is992 = useBreakpoint(LayoutConst.screen.m);

  const offsetVisible = useMemo(() => (!!tab), [tab]);

  const isHseDeziiign = AppTester.isHSEDesign();
  const gameSpecialCondition = isSuperPuperGames && is992 && !is743;

  const maxRowCount = gameSpecialCondition ? 4 : rowCount;
  const cutLastTab = maxRowCount - 1

  const computeItems = useMemo(() => {
    if (items && !isLoading && !localLoading) {
      if (Object.keys(items)?.length > maxRowCount) {
        if (activeDropdownTab) {
          const visibleItems = Object.entries(items)?.slice(0, cutLastTab);
          const activeTabEntry = activeDropdownTab;
          return [...visibleItems, activeTabEntry]?.reduce((a,[k,v]) => ({...a, [k]: v}), {});
        }
        return Object.entries(items)?.slice(0, maxRowCount)?.reduce((a,[k,v]) => ({...a, [k]: v}), {});
      }
      return items;
    }
    return items
  }, [items, isDropdown, isLoading, localLoading, activeDropdownTab, maxRowCount, cutLastTab])


  const computedDropdownItems = useMemo<Record<string, LinksItems> | null>(() => {
    if (items && !isLoading && !localLoading) {
      const activeTab = activeIndexKey ? activeDropdownTab?.[0]: undefined;
      const lastTabInRow: [string,string] | [] = activeDropdownTab ? Object.entries(items)?.[Object.entries(items)?.slice(0,maxRowCount)?.length - 1] : [];

      if (Object.keys(items)?.length > maxRowCount) {
        const lastTabRow = !!lastTabInRow ? lastTabInRow : []
        const filteredItems = [...Object.entries(items), lastTabRow];

        return filteredItems
          ?.slice(maxRowCount, filteredItems?.length)
          ?.filter(([k, v]) => activeTab ? k !== activeTab : k )
          ?.reduce((a,[k,v]) => ({...a, [k || '']: v}), {})
      }
      return null;
    }
    return null;
  } , [
    items,
    isLoading,
    localLoading,
    activeDropdownTab,
    activeIndexKey,
    maxRowCount
  ])

  const rightSideWidth = useMemo(() => {
    return document.querySelector('.js-right-side-box')?.clientWidth || 0
  } , [dropdownRef?.current])

  const searchBarWidth = useMemo(
    () => (
      rightSideWidth > 0 ? rightSideWidth : 
      isDesigner ? designerBarWidth : 
      (isTeamEdit || (isTeamOrCoursePage && !isMobile)) ? 0 : 
      SEARCH_BAR_WIDTH) 
  , [isDesigner, rightSideWidth])

  useEffect(() => {
    //костыль для ресета размера элементов при смене языка
    if (langRef.current !== i18n.language) {
      setSizes({})
      setLocalLoading(true)
    }
    langRef.current = i18n.language
    setLocalLoading(false);
  } , [i18n.language])

  useEffect(() => {
    return () => {
      if (leaveTimeoutRef.current) {
        clearTimeout(leaveTimeoutRef.current);
      }
    };
  }, [])

  useEffect(() => {
    if(tabsContainerRef?.current && hoverElem) {
      const el = tabsContainerRef.current?.querySelector(`[data-title="${hoverElem}"]`);
      const key = el?.dataset?.['title'];

      if (computedDropdownItems && Object.keys(computedDropdownItems)?.includes(key) && dropdownRef.current) {
        setPos({
          x: dropdownRef.current.offsetLeft || 0,
          y: el?.offsetTop
        });
        return;
      }
      if (el) {
        setPos({ x: el?.offsetLeft, y: 0 });
      }
    } else if (!hoverElem) {
      setPos({ x: null, y: null });
    }
  }, [tabsContainerRef, hoverElem, computedDropdownItems, dropdownRef])

  useEffect(() => {

    if (!computedDropdownItems) return;

    const isDropdownOpen = dropdownRef.current?.querySelector('.show')

    const hasItemIntoDropdown = Object.keys(computedDropdownItems)?.includes(hoverElem ?? '')

    if (hasItemIntoDropdown) return;

    if (hoverElem && isDropdownOpen) {
      isDropdownOpen?.classList.remove('show')
    }

  } , [dropdownRef?.current, hoverElem, computedDropdownItems])

  useEffect(() => {
    if (activeIndexKey && computedDropdownItems) {
      const activeItem = Object.entries(computedDropdownItems)?.find(([k, v]) => k === activeIndexKey);

      if (activeItem?.length) {
        setActiveDropdownTab(activeItem)
      }

    } else {
      setActiveDropdownTab(null)
    }
  }, [activeIndexKey, isDropdown, computedDropdownItems, i18n.language, t, items])


  const calcGap = useCallback(() => {
    if (is992) return 16;
    return 24;
  }, [is992])

  const calcRow = useCallback((maxWidth: number) => {
    const currentCountGap = (n: number) => calcGap() * n - 1

    let result = { overWidth: 0, lastRow: 0 };

    Object.entries(sizesInfo).forEach(([item, width], idx, arr) => {
      if (result.lastRow > 0) return;


      if (((result.overWidth + (width as number)) + currentCountGap(idx)) > maxWidth) {
        result = { overWidth: result.overWidth, lastRow: idx - 1 };
        return;
      }
      result = { overWidth: result.overWidth += (width as number), lastRow: 0 };
    });

    return result;
  } , [sizesInfo, calcGap])

  const onSetRowCount = useCallback((data: any) => {
    if (data !== rowCount && !!data) {
      setRowCount(data)
    }
  } , [rowCount])
 

  const countDuplicates = useCallback((arr: any[]) => {
    const counts = arr.reduce((acc, item) => {
      acc[item] = (acc[item] || 0) + 1;
      return acc;
    }, {});
    // @ts-ignore
    return Object.values(counts).filter(count => count > 1).length;
  }, []);

  useLayoutEffect(() => {
    if (localLoading) return
    const mobileSeachBarWidth = isTeamOrCoursePage && isMobile && !is743 ? 0 : searchBarWidth

    const mainContainerWidth = !!is992 ?  LayoutConst.container.xs : !!is1280 ? LayoutConst.container.m : LayoutConst.container.l
    const maxContainerWidth = mainContainerWidth - mobileSeachBarWidth;
    
    //@ts-ignore
    const computeItemsValues = Object.values(computeItems);
    const sizesInfoValues = Object.values(sizesInfo);
    
    // Подсчитываем количество дублирующихся элементов в computeItems
    const duplicateCount = countDuplicates(computeItemsValues);

    // Новая длина sizesInfo, учитывающая дублирующиеся элементы
    const adjustedSizesInfoLength = sizesInfoValues.length + duplicateCount;

    if ((adjustedSizesInfoLength === computeItemsValues.length || adjustedSizesInfoLength > computeItemsValues.length) && !isLoading) {
      const baseGap = calcGap() * adjustedSizesInfoLength;
      const overWidth = sizesInfoValues.reduce((acc, val) => acc + val, 0);
      const baseValue = items && Object.values(items)?.length > 0 ? Object.values(items)?.length : INITIAL_ROW_COUNT;
      const needBreak = (overWidth + baseGap) > maxContainerWidth;

      if (!needBreak) {
        onSetRowCount(baseValue);
        return;
      }

      const { lastRow } = calcRow(maxContainerWidth);
      onSetRowCount(lastRow)
  }
  } , [
    sizesInfo,
    activeDropdownTab,
    searchBarWidth,
    tabsContainerRef.current,
    computeItems,
    isLoading,
    localLoading,
    items,
    is1280,
    is992,
    onSetRowCount,
    calcGap,
    calcRow,
    countDuplicates
  ])

  const activeDropdownItem = useMemo(() => {
    if (!activeDropdownTab) return null;

    const [key, item] = activeDropdownTab;
    const title = typeof item === 'string' ? item : item?.element?.();
    setTitleSize(title.length)
    return (
      <SlideNavigationWrapperItem
        className={"white_theme_project_underline"}
        isDesigner={isDesigner}
        isHseDeziiign={isHseDeziiign}
        onClick={onChangeHandler(key)}
        onMouseEnter={() => onSetHoverTab(key)}
        active={key === activeIndexKey}
        //@ts-ignore
        dataName={hoverDataName?.[key]}
        data-title={key}
        white_theme={whiteTheme}
        padding={padding}
        whiteSpace={whiteSpace}
        blueSelect={blueSelect}
        disableTab={key !== activeIndexKey && disableTab}
        isTitle={isTitle}
        smallTab={smallTab}
        offsetVisible={offsetVisible}
        floatingTabs={floatingTabs}
        isTeamOrCoursePage={isTeamOrCoursePage}
      >
        {title}
      </SlideNavigationWrapperItem>
    )
  } , [
    activeDropdownTab, 
    activeIndexKey, 
    computeItems,
    items, 
    hoverDataName, 
    t, 
    onSetHoverTab, 
    disableTab, 
    isDesigner, 
    whiteTheme,  
    isTitle, 
    smallTab, 
    items, 
    i18n.language, 
    offsetVisible, 
    blueSelect 
  ])

  const dropdown = useMemo(() => {

    if (!computedDropdownItems) return null;

    return (
        <DropdownItemsWrapper
          isCompetition={isCompetition}
          //todo вынести выше или в тему
          isWhite={dropdownWhiteTheme}
          ref={dropdownRef}
          rightPos={titleSize > 8}
          leftPos={isLMSHomework && titleSize === 0}
        >
          <Dropdown
              hideArrow
              maxWidth={403}
              dark={whiteTheme}
              offsetX={-180}
              orientation='left'
              {...(dropdownWhiteTheme && { maxHeight: 300 })}
              target={
                <MoreButton
                  onClick={() => setHoverElem(null)}
                />
              }
          >
            {Object.keys(computedDropdownItems)?.map((item, idx, arr) => {
              const isLink = typeof computedDropdownItems[item] !== 'string';
              return (
                  <DropdownListItem
                  //@ts-ignore
                    dataName={hoverDataName?.[item]}
                    data-title={item}
                    onMouseEnter={() => onSetHoverTab(item)}
                    isActive={item === activeIndexKey}
                    onClick={isLink ? computedDropdownItems[item].action : onChangeHandler(item)}
                    key={idx}
                  >
                    {/*@ts-ignore*/}
                    {(typeof computedDropdownItems[item] === 'string' ? computedDropdownItems[item] : computedDropdownItems[item]?.element?.() || '')?.toLowerCase?.()}
                  </DropdownListItem>
              )
            })}
                  </Dropdown>
        </DropdownItemsWrapper>
    )
  } , [computedDropdownItems, onChangeHandler, activeIndexKey, hoverDataName, hoverContent, isCompetition, hoverElem, pos, blueSelect, dropdownWhiteTheme])

  const visibleItems = computeItems;

  const handleTagClick = useCallback((tagId: string) => {
    if (onTagClick) {
      onTagClick({ tagId, tab: hoverElem })
    }
  }, [hoverElem]);

  const onHoverPopupMouseEnter = useCallback(() => {
    if (leaveTimeoutRef.current) {
      clearTimeout(leaveTimeoutRef.current);
      leaveTimeoutRef.current = null;
    }
  }, []);

  const onHoverPopupMouseLeave = useCallback((event: MouseEvent) => {
    const relatedTarget = event.relatedTarget as Node;
    const currentTarget = event.currentTarget;

    //@ts-ignore
    if (relatedTarget instanceof Node && currentTarget && currentTarget.contains(relatedTarget)) {
      return;
    }

    onSetHoverTab(null)
  }, [onSetHoverTab]);



  const tabsComponent = useMemo(() => {
    if (hoverPopup && hoverContent && hoverDataName ) {
      return (
        <HoverContainer 
          hoverRef={hoverPopUpRef}
          onMouseEnter={onHoverPopupMouseEnter}
          onMouseLeave={onHoverPopupMouseLeave}
        >
        <SlideNavigationLayout
          autoWidth={autoWidth}
          autoFlex={autoFlex}
          isDesigner={isDesigner}
          isLoading={isLoading || localLoading}
          content={
            visibleItems ? (
            <SlideNavigationItemsWrapper ref={tabsContainerRef} wrap="nowrap" wrapMobile="nowrap" offsetBottomMobile={-4} isDesigner={isDesigner} overflowX={overflowX}>
              {Object.keys(visibleItems).map((key) => {
                const isLink = typeof items?.[key] !== 'string';
                return (
                  <SlideWithHover 
                    key={key}
                    //@ts-ignore
                    onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                    active={key === activeIndexKey}
                    whiteTheme={whiteTheme}
                    isDesigner={isDesigner}
                    blueSelect={blueSelect}
                    padding={padding}
                    whiteSpace={whiteSpace}
                    disableTab={key !== activeIndexKey && disableTab}
                    isTitle={isTitle}
                    dataName={hoverDataName[key]}
                    dataTitle={key}
                    onSetSizes={onSetSizes}
                    onSetActiveTab={onSetHoverTab}
                    importantItemColor={importantItemColor}
                    //@ts-ignore
                    item={isLink ? items[key]?.element() : capitalize ? items[key] : items[key]}
                  />
                )
              })}
              {dropdown}
            </SlideNavigationItemsWrapper>
          ) : null
        }
          sceletonOptions={sceletonOptions}
        />
        <TagsPopUp 
          list={hoverContent} 
          currentTab={hoverElem} 
          visible={!!hoverElem} 
          coor={pos} 
          blueSelect={blueSelect} 
          onTagClick={onTagClick ? handleTagClick : undefined}
          onMouseEnter={onHoverPopupMouseEnter}
        />
      </HoverContainer>
      )
    }
    return (
      <SlideNavigationLayout
      autoWidth={autoWidth}
      autoFlex={autoFlex}
      isDesigner={isDesigner}
      isLoading={isLoading || localLoading}
      stretch={stretch}
      fullWidth={fullWidth}
      content={
        computeItems ? (
          <ScrollableSlideNavigationItems isDesigner={isDesigner} stretch={stretch} fullWidth={fullWidth} smallTab={smallTab} isTitle={isTitle}>
            {Object.keys(computeItems).sort((a, b) => a === 'competitionCerts' ? 1 : b === 'competitionCerts' ? -1 : 0).map((key, idx, arr) => {
              //@ts-ignore
              const isLink = typeof computeItems[key] !== 'string';
              //@ts-ignore
              const isEmptyProjects = typeof computeItems[key] === 'string' && computeItems[key]?.split('|')[1]?.trim() === '0'
 
              return (
                // @ts-ignore
                <SlideWithHover
                  key={key}
                  //@ts-ignore
                  onClick={isLink ? items[key]?.action : onChangeHandler(key)}
                  active={key === activeIndexKey}
                  whiteTheme={whiteTheme}
                  isDesigner={isDesigner}
                  blueSelect={blueSelect}
                  padding={padding}
                  whiteSpace={whiteSpace}
                  disableTab={key !== activeIndexKey && disableTab}
                  isTitle={isTitle}
                  onSetSizes={onSetSizes}
                  isEmptyProjects={isEmptyProjects}
                  //@ts-ignore
                  item={isLink ? items[key]?.element() : capitalize ? items[key] : items[key]}
                >
                {/*@ts-ignore*/}
                {isLink ? computeItems[key]?.element() : capitalize ? computeItems[key] : computeItems[key]}
                {arrowIconId === key && (
                  <ArrowCornerSvg clr={Colors.galBlack47} opacity={'1'} />
                )}
              </SlideWithHover>
              )
            })}
            <DropdownWrapper>
              {dropdown}
            </DropdownWrapper>
          </ScrollableSlideNavigationItems>
        ) : null
      }
      sceletonOptions={sceletonOptions}
    />
    )
  } , [
    computeItems, 
    visibleItems, 
    i18n.language, 
    localLoading,
    hoverElem,
    pos,
    activeDropdownItem,
    activeIndexKey,
    sceletonOptions,
    blueSelect,
    isDesigner,
    whiteTheme,
    isLoading,
  ])

  return tabsComponent
};

export default SlideNavigation;
